import ErrorBoundary from "../../ErrorBoundary";
import React,{Component} from "react";
import * as f from "../../common/Funcs";
import BaseByMapPage from "../../Base/BaseByMapPage";
import BaseGridPage from "../../Base/BaseGridPage";
import {Circle as CircleStyle, Fill, Style} from "ol/style";

const keyName = `MappingsPage`;

export default class MappingsPage extends BaseByMapPage {
    constructor(props) {
        super(props);
        const context = this;
        if (window.IasConfig.devMode) console.debug(`${keyName} constructor`, props);
        const now=new Date();
        document.setCookie('toFilter',now.toLocaleDateString());
        // now.setFullYear(now.getFullYear()-1);
        // document.setCookie('fromFilter',now.toLocaleDateString());
        context.title=`список фактов встреч`;
        context.gridName="MappingsGrid";
        context.subElementName = 'MappingPage';
        context.tableName = 'mappings';
        context.filters = [
            {name: 'from', required: true, message: f.locale('needfrom')},
            {name: 'to', required: true, message: f.locale('needto')},
            {name: 'region', required: false,gisSearch:true},
            {name: 'users', required: false},
            {name: 'meetspec', required: false},
            {name: 'num', required: false},
            {name: 'page', required: false},
            // {name: 'male', required: false},
            // {name: 'age', required: false},
            // {name: 'fio', required: false},
            // {name: 'char', required: false},

        ]
        context.styleFunction=(feature)=>{
            const specId = feature.getProperties().spec_name;
            const radius = 4;
            const colors = {
                'Косуля': [144, 255, 144, 1],
                'Кабан': [224, 255, 50, 1],
                'Бурый медведь': [230, 170, 20, 1],
                'Лось': [245, 105, 105, 1],
                'Речной бобр': [255, 105, 215, 1],
                'Волк': [125, 125, 125, 1]
            };
            const w = new Style({
                image: new CircleStyle({
                    radius: radius + 1,
                    fill: new Fill({
                        color: [0, 0, 0, 1],
                    }),
                }),
            });
            const p = new Style({
                image: new CircleStyle({
                    radius: radius,
                    fill: new Fill({
                        color: colors[specId] || [100, 100, 255, 1],
                    }),
                }),
            });
            return [w, p];
        }
        // [
            // {name: 'from', required: true, message: f.locale('needfrom')},
            // {name: 'to', required: true, message: f.locale('needto')},
            // {name: 'region', required: false},
            // {name: 'users', required: false},
            // {name: 'meetspec', required: false},
            // {name: 'page', required: false},
            // {name: 'fio', required: false},
            // {name: 'char', required: false},
        // ]
    }
}